// extracted by mini-css-extract-plugin
export default {"inputTitle":"EditProfile_inputTitle__XqLa0","title":"EditProfile_title__jkYOC"};